<p>player-class-editor works!</p>

<div class="mb-3">
    <label for="name" class="form-label">Name</label>
    <input type="email" class="form-control" id="name" [(ngModel)]="model.name" />
</div>